<div class="error">
  <img
    class="error__image"
    alt="ilustração de imagem não existente"
    src="../../../assets/imgs/errors-pages/error-banner.png"/>
  <div class="error__container">
    <h3 class="error__container__title">Prezado usuário</h3>
    <div class="error__container__text-container">
      <span class="error__container__text-container__text">No momento, alguns serviços estão temporariamente indisponíveis. Para fazer login, 
        tente novamente em alguns minutos. Voltar à página inicial.</span>
      <span class="error__container__text-container__text">
        <a class="error__container__text-container__text__link" [href]="portalUrl">Voltar à página inicial</a>
      </span>
    </div>
  </div>
</div>
